import Sentry, { initSentry as init } from '@nykaa/logger/sentry';

export const initSentry = () => {
  if (process.env.NODE_ENV === 'development') {
    return;
  }

  init({
    release: __VERSION__,
    denyUrls: [
      /graph\.facebook\.com/i,
      /connect\.facebook\.net\/en_US\/all\.js/i,
      /extensions\//i,
      /^chrome:\/\//i,
      /assets\.adobedtm\.com/i,
      /netcoresmartech\.com/i,
      /verloop\.io/i,
    ],
    ignoreErrors: [
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'atomicFindClose',
      'fb_xd_fragment',
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      'failed to fetch',
      /.*Bad Gateway.*/i,
      /.*Blocked a frame with origin.*/i,
      /.*failed to fetch.*/i,
      /.*hostname could not.*/i,
      /.*connect to the server.*/i,
      /.*Loading chunk.*failed.*/i,
      /.*Network request failed.*/i,
      /.*offline.*/gi,
      /.*abort.*/i,
      /.*timeout.*/i,
      /.*timed out.*/i,
      /.*connection.*lost.*/i,
      /.*cancelled.*/i,
    ],
    tracesSampleRate: 0.2,
  });
};

export { log, info, setUserScope, setCustomScope, captureEvent } from '@nykaa/logger/sentry';
export default Sentry;
